import {useNavigate} from 'react-router-dom';

import * as urlUtils from '../../../../utils/urlUtils';

import {cartConstants} from '../index';


/**
 * @return {(function({string}): null)|*} Go to checkout function requiring cartId as parameter
 */
function useGoToCheckout() {

    const navigate = useNavigate();

    return function goToCheckout(cartId) {

        const cartUrl = urlUtils.buildPath(
            cartConstants.NAV_PAGE_CHECKOUT,
            {
                cartId
            }
        );

        navigate(cartUrl);

        return null;
    };
}


export default useGoToCheckout;
